const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  theme: state => state.app.theme,
  imageLayout: state => state.app.imageLayout,
  floorInfo: state => state.app.floorInfo,
  floorInfoInit: state => state.app.floorInfoInit,
  floors: state => state.business.floors,
  token: state => state.user.token,
  name: state => state.user.name,
  groups: state => state.user.groups,
  userId: state => state.user.id,
  userGroup: state => state.user.userGroup,
  groupType: state => state.user.groupType,
  ajaxCount: state => state.app.ajaxCount,
  allUsers: state => state.cache.allUsers,
  allGroups: state => state.cache.allGroups,
  allDepartments: state => state.cache.allDepartments,
};
export default getters;
